var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyteDiscoveryOutOfStockMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7246 2.40189C13.7246 1.6611 13.124 1.06057 12.3832 1.06057L9.88776 1.06057L9.88776 -1.99799e-07L12.3832 -9.79906e-08C13.7098 -4.38719e-08 14.7852 1.07536 14.7852 2.40189L14.7852 4.89736L13.7246 4.89736L13.7246 2.40189Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.06058 2.40189C1.06058 1.6611 1.66111 1.06057 2.40191 1.06057L4.8974 1.06057L4.8974 2.14072e-07L2.40191 1.04991e-07C1.07537 4.7006e-08 -4.70056e-08 1.07536 -1.0499e-07 2.40189L-2.1407e-07 4.89736L1.06058 4.89736L1.06058 2.40189Z",
    fill: "#4A4A4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3832 13.7253C13.124 13.7253 13.7246 13.1248 13.7246 12.384L13.7246 9.88853L14.7852 9.88853L14.7852 12.384C14.7852 13.7105 13.7098 14.7859 12.3832 14.7859L9.88776 14.7859L9.88776 13.7253L12.3832 13.7253Z",
    fill: "#4A4A4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.06058 12.384C1.06058 13.1248 1.66111 13.7253 2.40191 13.7253L4.8974 13.7253L4.8974 14.7859L2.40191 14.7859C1.07537 14.7859 1.31617e-07 13.7105 2.93974e-07 12.384L5.99402e-07 9.88853L1.06058 9.88853L1.06058 12.384Z",
    fill: "#4A4A4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92228 6.769C8.92228 7.90602 8.00053 8.82776 6.8635 8.82776C5.72647 8.82776 4.80472 7.90602 4.80472 6.769C4.80472 5.63197 5.72647 4.71023 6.8635 4.71023C8.00053 4.71023 8.92228 5.63197 8.92228 6.769ZM8.6624 9.3177C8.15406 9.67714 7.53344 9.88833 6.8635 9.88833C5.14073 9.88833 3.74414 8.49176 3.74414 6.769C3.74414 5.04623 5.14073 3.64966 6.8635 3.64966C8.58628 3.64966 9.98286 5.04623 9.98286 6.769C9.98286 7.43887 9.77171 8.05943 9.41232 8.56774L11.6056 10.761L10.8556 11.5109L8.6624 9.3177Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyteDiscoveryOutOfStockMobile);
export default __webpack_public_path__ + "static/media/syte-discovery-out_of-stock-mobile.c69a3c20.svg";
export { ForwardRef as ReactComponent };